<template>
  <div class="container">
    <!-- <transition name="slide-move-horizontal"> -->
      <!-- <div :class="{'slide-btn': true, 'collapsed': !collapse}" @click="collapse = !collapse">
        <span :class="{'el-icon-back': true, 'rotated': !collapse}"></span>
      </div> -->
    <!-- </transition> -->
    <el-container>
      <transition name="el-zoom-in-center">
        <el-aside width="250px" v-show="collapse">
          <div class="menu-wrapper">
            <tree-menu :modulesConfig="modulesConfig" @menu-click="handleMenuClick"></tree-menu>
          </div>
        </el-aside>
      </transition>
      <el-main>
        <div class="sheet-content" :style="`background:${iframeClickIndex ? 'none' :'#ffffff'}`">
          <!-- <router-view></router-view> -->
          <!-- <iframe
            security="restricted"
            style="width: calc(100% + 165px); height: calc(100% + 70px)"
            class="iframe"
            frameborder="0"
            ref="iframe"
            :src="iframeSrc"></iframe> -->
            <file-management ref="management" v-if="iframeClickIndex"></file-management>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import 'element-ui/lib/theme-chalk/base.css';
import treeMenu from './treeMenu/treeMenu'
import fileManagement from './common/fileManagement'
export default {
  name: 'shortVideoManagement',
  mixins: [pagePathMixin],
  components: { treeMenu, fileManagement },
  data() {
    return {
      modulesConfig: {
        appCode: 'e-commerce',
        subAppCode: 'ec-pc-new'
      },
      collapse: true,
      iframeSrc: '',
      iframeClickIndex: 0,
    }
  },
  watch: {
    // iframeSrc(val,old) {
    //   if(!val.includes('fileManagement')) {
    //     this.iframeSrc = old
    //   }
    // }
  },
  mounted() {
  },
  methods: {
    handleMenuClick(p) {
      this.iframeClickIndex += 1
      console.log(p);
      this.iframeSrc = p;
      var iframe_home = this.$refs.management
      if(this.iframeClickIndex != 1) {
        setTimeout(() => {
          this.$refs.management.resetTableSort()
          this.$refs.management.onSearch(p.dataId)
          this.$refs.management.fliePath = p.path
            // iframe_home.contentWindow.resizeWindow()
        }, 500);
      }else {
        setTimeout(() => {
          var iframe_home = this.$refs.management
          if(iframe_home) {
            this.$refs.management.resetTableSort()
             this.$refs.management.onSearch(p.dataId)
             this.$refs.management.fliePath = p.path
            // iframe_home.contentWindow.resizeWindow()
          }
        }, 3000);
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .container
    padding 5px
    height 100%
    width 100%
    box-sizing border-box
    position relative

  >>> .el-container
    height 100%
    .el-main
      padding 0
      padding-left 5px
  .menu-wrapper
    width 100%
    height 100%
    background #ffffff
    border-radius 5px
    position relative
    padding-top 0.1px
    box-sizing border-box
  .sheet-content
    width 100%
    height 100%
    // background #ffffff
    border-radius 5px
    padding-top 0.1px
    box-sizing border-box
    overflow hidden
    position relative
    .iframe
      position absolute
      right 0
      bottom 0
      z-index 999

  .slide-btn
    cursor pointer
    width 50px
    height 50px
    background rgb(31,173,128)
    text-align center
    line-height 58px
    position absolute 
    left 220px
    top 20px
    z-index 1000
    transition all cubic-bezier(.72,.01,.13,1) .6s
  >>> .el-icon-back
    color #ffffff
    font-size 24px
    transition all linear .4s

  .collapsed
    transform translate(-220px, 0)
  .rotated
    transform rotate(540deg)
</style>